// File: frontend/src/routes/index.js

import React from 'react';
import { Routes, Route } from 'react-router-dom';
import PrivateRoute from './PrivateRoute';
import PublicRoute from './PublicRoute';
import AdminRoute from './AdminRoute';
import { ROUTES } from './routes';

// Layouts
import MainLayout from '../components/layout/MainLayout';
import DashboardLayout from '../components/layout/DashboardLayout';

// Public Pages
import Home from '../views/public/Home';
import About from '../views/public/About';
import Contact from '../views/public/Contact';
import Pricing from '../views/public/Pricing';
import Products from '../views/public/Products';
import ProductPage from '../views/public/ProductPage';
import PrivacyPolicy from '../views/public/PrivacyPolicy';
import TermsOfService from '../views/public/TermsOfService';
import SMSTerms from '../views/public/SMSTerms';
import VerifyEmail from '../views/public/VerifyEmail';
import NotFound from '../views/public/NotFound';
import NewsletterUnsubscribe from '../views/public/NewsletterUnsubscribe';
import NewsletterResubscribe from '../views/public/NewsletterResubscribe';
import NewsletterPreferences from '../views/public/NewsletterPreferences';

// Private Pages
import Dashboard from '../views/private/Dashboard';
import Account from '../views/private/Account';
import Upload from '../views/private/Upload';
import Policies from '../views/private/Policies';
import PolicyDetails from '../views/private/PolicyDetails';
import Claims from '../views/private/Claims';
import Chat from '../views/private/Chat';
import Chats from '../views/private/Chats';
import AutoPolicyAnalytics from '../components/policy/AutoPolicyAnalytics';

// Admin Pages
import UMS from '../views/private/admin/UMS';
import QMS from '../views/private/admin/QMS';
import EMS from '../views/private/admin/EMS';
import TMS from '../views/private/admin/TMS';
import UPS from '../views/private/admin/UPS';
import AI from '../views/private/admin/AI';
import DMS from '../views/private/admin/DMS';

const AppRoutes = () => {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path={ROUTES.HOME} element={<PublicRoute><MainLayout><Home /></MainLayout></PublicRoute>} />
      <Route path={ROUTES.ABOUT} element={<PublicRoute><MainLayout><About /></MainLayout></PublicRoute>} />
      <Route path={ROUTES.CONTACT} element={<PublicRoute><MainLayout><Contact /></MainLayout></PublicRoute>} />
      <Route path={ROUTES.PRICING} element={<PublicRoute><MainLayout><Pricing /></MainLayout></PublicRoute>} />
      <Route path={ROUTES.PRODUCTS_OVERVIEW} element={<PublicRoute><MainLayout><Products /></MainLayout></PublicRoute>} />
      <Route path={ROUTES.PRODUCTS} element={<PublicRoute><MainLayout><ProductPage /></MainLayout></PublicRoute>} />
      <Route path={ROUTES.PRIVACY} element={<PublicRoute><MainLayout><PrivacyPolicy /></MainLayout></PublicRoute>} />
      <Route path={ROUTES.TERMS} element={<PublicRoute><MainLayout><TermsOfService /></MainLayout></PublicRoute>} />
      <Route path={ROUTES.SMS_TERMS} element={<PublicRoute><MainLayout><SMSTerms /></MainLayout></PublicRoute>} />
      <Route path={ROUTES.VERIFY_EMAIL} element={<PublicRoute><VerifyEmail /></PublicRoute>} />
      <Route path={ROUTES.NEWSLETTER_UNSUBSCRIBE} element={<PublicRoute><NewsletterUnsubscribe /></PublicRoute>} />
      <Route path={ROUTES.NEWSLETTER_RESUBSCRIBE} element={<PublicRoute><NewsletterResubscribe /></PublicRoute>} />
      <Route path={ROUTES.NEWSLETTER_PREFERENCES} element={<PublicRoute><NewsletterPreferences /></PublicRoute>} />

      {/* Private Routes */}
      <Route path={ROUTES.DASHBOARD} element={<PrivateRoute><DashboardLayout><Dashboard /></DashboardLayout></PrivateRoute>} />
      <Route path={ROUTES.ACCOUNT} element={<PrivateRoute><DashboardLayout><Account /></DashboardLayout></PrivateRoute>} />
      <Route path={ROUTES.UPLOAD} element={<PrivateRoute><DashboardLayout><Upload /></DashboardLayout></PrivateRoute>} />
      <Route path={ROUTES.POLICIES} element={<PrivateRoute><DashboardLayout><Policies /></DashboardLayout></PrivateRoute>} />
      <Route path={ROUTES.POLICY_DETAILS} element={<PrivateRoute><DashboardLayout><PolicyDetails /></DashboardLayout></PrivateRoute>} />
      <Route path={ROUTES.POLICY_ANALYTICS} element={<PrivateRoute><DashboardLayout><AutoPolicyAnalytics /></DashboardLayout></PrivateRoute>} />
      <Route path={ROUTES.CLAIMS} element={<PrivateRoute><DashboardLayout><Claims /></DashboardLayout></PrivateRoute>} />
      <Route path={ROUTES.CHATS} element={<PrivateRoute><DashboardLayout><Chats /></DashboardLayout></PrivateRoute>} />
      <Route path={ROUTES.CHAT_DETAIL} element={<PrivateRoute><DashboardLayout><Chat /></DashboardLayout></PrivateRoute>} />

      {/* Admin Routes */}
      <Route path={ROUTES.UMS} element={<AdminRoute><DashboardLayout><UMS /></DashboardLayout></AdminRoute>} />
      <Route path={ROUTES.QMS} element={<AdminRoute><DashboardLayout><QMS /></DashboardLayout></AdminRoute>} />
      <Route path={ROUTES.EMS} element={<AdminRoute><DashboardLayout><EMS /></DashboardLayout></AdminRoute>} />
      <Route path={ROUTES.TMS} element={<AdminRoute><DashboardLayout><TMS /></DashboardLayout></AdminRoute>} />
      <Route path={ROUTES.UPS} element={<AdminRoute><DashboardLayout><UPS /></DashboardLayout></AdminRoute>} />
      <Route path={ROUTES.AI} element={<AdminRoute><DashboardLayout><AI /></DashboardLayout></AdminRoute>} />
      <Route path={ROUTES.DMS} element={<AdminRoute><DashboardLayout><DMS /></DashboardLayout></AdminRoute>} />

      {/* 404 */}
      <Route path="*" element={<MainLayout><NotFound /></MainLayout>} />
    </Routes>
  );
};

export default AppRoutes;